(function () {
  'use strict';

  function parseDataIsland(sectionId) {
    var node = document.getElementById('preorder-data-' + sectionId);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      console.warn('[preorder] Failed to parse data island for section', sectionId, e);
      return null;
    }
  }

  function findButtonsInSection(sectionId) {
    var section =
      document.getElementById('shopify-section-' + sectionId) ||
      document.querySelector('[data-section-id="' + sectionId + '"]') ||
      document;
    return section.querySelectorAll('.single-add-to-cart-button, [data-preorder-cta]');
  }

  function updateButton(button, info) {
    var ctaSpan = button.querySelector('[data-preorder-cta]');
    var fallbackSpan = button.querySelector('.single-add-to-cart-button--text');
    var isPreorder = info && info.state && info.state !== 'none';

    button.classList.toggle('single-add-to-cart-button--preorder', isPreorder);

    if (isPreorder) {
      if (ctaSpan) {
        ctaSpan.textContent = info.ctaText || '';
      } else if (fallbackSpan) {
        fallbackSpan.textContent = info.ctaText || '';
      }
      button.classList.remove('sold-out');
      button.removeAttribute('disabled');
    }
  }

  function updateBanner(sectionId, info) {
    var banner = document.getElementById('preorder-' + sectionId);
    if (!banner) return;

    var isPreorder = info && info.state && info.state !== 'none';
    banner.classList.toggle('preorder-message--hidden', !isPreorder);
    banner.classList.remove('preorder-message--preorder', 'preorder-message--backorder', 'preorder-message--none');
    banner.classList.add('preorder-message--' + (info ? info.state : 'none'));

    if (isPreorder) {
      var dateEl = banner.querySelector('[data-preorder-date]');
      if (dateEl) dateEl.textContent = info.shipDate || '';
    }
  }

  function updateHiddenProperty(sectionId, info) {
    var wrapper = document.getElementById('preorder-property-' + sectionId);
    if (!wrapper) return;

    var isPreorder = info && info.state && info.state !== 'none';
    var shipDate = isPreorder ? info.shipDate : '';

    var existing = wrapper.querySelector('[data-preorder-property]');
    if (shipDate) {
      if (existing) {
        existing.value = shipDate;
      } else {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Estimated Shipping]';
        input.value = shipDate;
        input.setAttribute('data-preorder-property', '');
        wrapper.appendChild(input);
      }
    } else if (existing) {
      existing.remove();
    }
  }

  function handleVariantChange(event) {
    var detail = event.detail || {};
    var sectionId = detail.sectionId;
    var variant = detail.variant;
    if (!sectionId || !variant) return;

    var map = parseDataIsland(sectionId);
    if (!map) return;

    var info = map[String(variant.id)] || { state: 'none' };

    updateBanner(sectionId, info);
    updateHiddenProperty(sectionId, info);

    var buttons = findButtonsInSection(sectionId);
    buttons.forEach(function (btn) {
      updateButton(btn, info);
    });
  }

  document.addEventListener('product:variant-change', handleVariantChange);
})();
